import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * ReportsCustomerView class extends JetView to create a specific view for customer reports.
 */
export default class ReportsCustomerView extends JetView {
    /**
     * Configures the layout and components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type to wide
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Set inner layout type to wide
                    rows: [
                        {
                            view: 'tabbar', // Create a tab bar
                            localId: 'tabbar', // Local ID for tab bar
                            height: 43, // Set height of the tab bar
                            tabMinWidth: 190, // Minimum width for tabs
                            tabMoreWidth: 80, // Width for 'more' tab
                            /**
                             * Template for the 'more' tab.
                             * @returns {string} HTML string for the 'more' tab.
                             */
                            moreTemplate: function () {
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Localized text for 'more'
                                    '</div>'
                                );
                            },
                            options: [
                                {
                                    id: 'security.adminuser.reports.logsUser', // ID for the report option
                                    value: _(
                                        'Logs Usuario', // Localized text for 'User Logs'
                                    ),
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Listen for person selection event
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
